module.exports = __webpack_public_path__ + "img/scene2.e2c960b8.gif";